/* eslint-disable */

import React from "react";
import { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { fetchGraphQL } from "../../../services/api-raindrop";
import { RAINDROP_SESSION_TOKEN_KEY } from "../../../services/constants";

const CirrusAuthenticate = () => {
  let navigate = useNavigate();

  let query = new URLSearchParams(useLocation().search);

  const tokenMagic = query.get("token");

  useEffect(() => {
    fetchGraphQL(`
        mutation {
          authenticateWithMagicToken(
            magicToken: "${tokenMagic}",
            application: "cirrus"
        ) {
            token
        }
      }
      `)
      .then((response) => {
        if (response?.data?.authenticateWithMagicToken) {
          const token = response?.data?.authenticateWithMagicToken.token;
          localStorage.setItem(RAINDROP_SESSION_TOKEN_KEY, token);
          navigate("/cirrus");
        } else {
          console.error(
            "Error verifying magic token.  Redirecting to entry. (RD-1233)",
            response
          );
          navigate("/cirrus/login");
        }
      })
      .catch((e) => {
        console.log("RD-3333", e);
      });
  }, []);

  return (
    <div
      className={
        "flex flex-col w-full h-full items-center justify-center text-color-text-tertiary"
      }
    >
      <div>Hold tight, we're verifying your magic token</div>
    </div>
  );
};

export default CirrusAuthenticate;
